import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { KeycloakParsedToken } from '../../types/token';

interface AuthState {
    isAuthenticated: boolean;
    token: string | null;
    userInfo: KeycloakParsedToken | null;
    openStackRegistered: boolean;
    provisioningTimedOut: boolean;
}

const initialState: AuthState = {
    isAuthenticated: false,
    token: null,
    userInfo: null,
    openStackRegistered: false,
    provisioningTimedOut: false,
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuthenticated: (
            state,
            action: PayloadAction<{
                isAuthenticated: boolean;
                token: string;
                userInfo: KeycloakParsedToken;
            }>
        ) => {
            state.isAuthenticated = action.payload.isAuthenticated;
            state.token = action.payload.token;
            state.userInfo = action.payload.userInfo;
        },
        setOpenStackRegistered: (state, action: PayloadAction<boolean>) => {
            state.openStackRegistered = action.payload;
        },
        setProvisioningTimedOut: (state, action: PayloadAction<boolean>) => {
            state.provisioningTimedOut = action.payload;
        },
        logout: (state) => {
            state.isAuthenticated = false;
            state.token = null;
            state.userInfo = null;
            state.openStackRegistered = false;
        },
    },
});

export const { setAuthenticated, setOpenStackRegistered, setProvisioningTimedOut, logout } = authSlice.actions;
export default authSlice.reducer;